module.exports = __webpack_public_path__ + "static/img/down_btn5.3c82e05.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cec2022/down_btn5.png
// module id = JE5z
// module chunks = 4